<template>
  <div class="general-wrapper">
      <div class="header">
          <h2 class="qrw-heading-xl">{{$t('navbar.subscriptions')}}</h2>
      </div>
      <div class="center-container px-50">
          <div class="one-column">
        <LocalSystemsPanel class="iqos-empty"/>
        <TransactionsHistory class="iqos-empty"/>

      
        </div>
      </div>
  </div>
</template>

<script>
import LocalSystemsPanel from '@/components/subscriptions/LocalSystemsPanel.vue'
import TransactionsHistory from "@/components/subscriptions/TransactionsHistory.vue"
 
export default {
    data() {
        return {
            
        }
    },
    components: {
        LocalSystemsPanel,
        TransactionsHistory
    }
}
</script>

<style>

</style>